/**
 * Copyright (C) Techniserv, spol. s r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

export default function ArticleRated({rating, namespace}) {
  const articleRated = document.createElement('div')
  articleRated.classList.add('article_feedback')

  const rateTime = rating && rating.time ? Date.parse(rating.time) : NaN
  const rateDateFormatted = rateTime > 0 ? new Date(rateTime).toLocaleDateString() : '?'
  console.log(rating.time, rateTime, rateDateFormatted)

  const heading = document.createElement('h3')
  heading.classList.add('feedback_heading')
  heading.appendChild(document.createTextNode(Liferay.Language.get('articlefeedback.wasRatedTitle')))

  const wasRatedText = Liferay.Language.get('articlefeedback.wasRatedText').replaceAll('{0}', rateDateFormatted)
  const text = document.createElement('p')
  text.classList.add('feedback_rated_text')
  text.appendChild(document.createTextNode(wasRatedText))

  articleRated.append(heading)
  articleRated.append(text)

  return articleRated
}